export default __webpack_public_path__ + "static/media/icons_facebook.af3b8498.svg";